module.exports = __webpack_public_path__ + "img/1534396316.9081ab34.jpg";